import React from 'react'

import {
  Blog,
  RnTracker,
  Weather,
  Epoxy,
  Pokemon,
  Barber,
  SoupLoop,
  EuBike,
  ADP2,
  Threejs,
} from '../img/index'

const Portfolio = () => {
  return (
    <section id="work" className="portfolio-mf sect-pt4 route">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="title-box text-center">
              <h3 className="title-a">My Projects 🛠</h3>
              <p className="subtitle-a">
                Coding Projects
                <span role="img" aria-label="emoji-laptop">
                  👨‍💻
                </span>
                <br />
              </p>
              <div className="line-mf" />
            </div>
          </div>
        </div>

        <div className="row">
          {/* Project 4 */}
          <div className="col-md-4">
            <div className="work-box">
              <div className="work-img">
                <img src={Blog} alt="ad-blog-cover" className="img-fluid" />
              </div>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12">
                    <h2 className="w-title">AD Performance Blog</h2>
                    <p className="box-info">
                      Blog about athlete development built with Next-JS, Sanity & Tailwind
                      CSS.
                    </p>
                    <span className="TS">
                      <iconify-icon data-icon="mdi:language-typescript" />
                    </span>
                    <span className="NextJS">
                      <iconify-icon data-icon="simple-icons:nextdotjs" />
                    </span>
                    <span className="Tailwind">
                      <iconify-icon data-icon="simple-icons:tailwindcss" />
                    </span>
                    <span className="Sanity">
                      <iconify-icon data-icon="simple-icons:sanity" />
                    </span>
                  </div>
                  <div className="col-sm-12">
                    <div className="socials">
                      <a
                        href="https://github.com/AD757/Nextjs-Sanity-Blog"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ico-circle">
                          <i className="ion-social-github" />
                        </span>

                        <a
                          href="https://adperformance-blog.vercel.app/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="ico-circle">
                            <i className="ion-link" />
                          </span>
                        </a>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Project 5  */}
          <div className="col-md-4">
            <div className="work-box">
              <div className="work-img">
                <img src={RnTracker} alt="Run tracker cover" className="img-fluid" />
              </div>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12">
                    <h2 className="w-title">Run Tracker</h2>
                    <p className="box-info">
                      Run Tracker is an application that helps users track their running
                      activities.
                    </p>
                    <span className="TS">
                      <iconify-icon data-icon="mdi:language-typescript" />
                    </span>
                    <span className="RN">
                      <iconify-icon data-icon="emojione-monotone:mobile-phone" />
                    </span>
                    <span className="FIREBASE">
                      <iconify-icon data-icon="bxl:firebase" />
                    </span>
                    <span className="EXPO">
                    <iconify-icon data-icon="logos:expo" />
                    </span>
                  </div>
                  <div className="col-sm-12">
                    <div className="socials">
                    <a
                        href="https://go.screenpal.com/watch/cZjTiQV99GK"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ico-circle">
                          <i className="ion-videocamera" />
                        </span>
                      </a>

                      <a
                        href="https://expo.dev/preview/update?message=V.1%20with%20expo&updateRuntimeVersion=1.0.0&createdAt=2024-07-25T13%3A31%3A41.902Z&slug=exp&projectId=7a216127-f190-4f35-91ed-4ccc7c2ec2e1&group=7d90c7cc-4f3b-4811-afb0-40b37790fd5d"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ico-circle">
                          <i className="ion-social-apple" />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Project  1*/}
          <div className="col-md-4">
            <div className="work-box">
              <div className="work-img">
                <img src={Pokemon} alt="Pokédex cover" className="img-fluid" />
              </div>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12">
                    <h2 className="w-title">Pokedéx</h2>
                    <p className="box-info">
                      Pokédex to fetch and displays Pokémons characters information.
                    </p>
                    <span className="TS">
                      <iconify-icon data-icon="mdi:language-typescript" />
                    </span>
                    <span className="RS">
                      <iconify-icon data-icon="mdi:react" />
                    </span>
                    <span className="API">
                      <iconify-icon data-icon="eos-icons:api" />
                    </span>
                    <span className="SC">
                      <iconify-icon data-icon="simple-icons:styled-components" />
                    </span>
                  </div>
                  <div className="col-sm-12">
                    <div className="socials">
                      <a
                        href="https://github.com/AD757/Pokedex-React"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ico-circle">
                          <i className="ion-social-github" />
                        </span>
                        <a
                          href="https://pokedex-ad757.netlify.app/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="ico-circle">
                            <i className="ion-link" />
                          </span>
                        </a>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Project 2 */}
          <div className="col-md-4">
            <div className="work-box">
              <div className="work-img">
                <img src={Threejs} alt="3D Animated Book" className="img-fluid" />
              </div>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12">
                    <h2 className="w-title">3D Animated Book</h2>
                    <p className="box-info">
                    Web application featuring an interactive 3D animated book with realistic animations.
                    </p>
                    <span className="ThreeJS">
                      <iconify-icon data-icon="logos:threejs" />
                    </span>
                    <span className="RS">
                      <iconify-icon data-icon="mdi:react" />
                    </span>
                    <span className="Tailwind">
                      <iconify-icon data-icon="mdi:tailwind" />
                    </span>
                  </div>
                  <div className="col-sm-12">
                    <div className="socials">
                    <a
                        href="https://github.com/AD757/3D-Book-threejs"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ico-circle">
                          <i className="ion-social-github" />
                        </span>
                        <a
                          href="https://3-d-book-threejs.vercel.app/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="ico-circle">
                            <i className="ion-link" />
                          </span>
                        </a>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Project  3*/}
          <div className="col-md-4">
            <div className="work-box">
              <div className="work-img">
                <img src={Weather} alt="Weather-app" className="img-fluid" />
              </div>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12">
                    <h2 className="w-title">Weather App</h2>
                    <p className="box-info">
                      Weather web app using Open Weather API that showcase current
                      weather.
                    </p>
                    <span className="JS">
                      <iconify-icon data-icon="mdi:language-javascript" />
                    </span>
                    <span className="RS">
                      <iconify-icon data-icon="mdi:react" />
                    </span>
                    <span className="API">
                      <iconify-icon data-icon="eos-icons:api" />
                    </span>

                    <span className="NODE">
                      <iconify-icon data-icon="fa-brands:node" />
                    </span>

                    <span className="SC">
                      <iconify-icon data-icon="simple-icons:styled-components" />
                    </span>
                  </div>
                  <div className="col-sm-12">
                    <div className="socials">
                      <a
                        href="https://github.com/AD757/Weather-App-V2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ico-circle">
                          <i className="ion-social-github" />
                        </span>
                        <a
                          href="https://ad-weather.surge.sh/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="ico-circle">
                            <i className="ion-link" />
                          </span>
                        </a>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="col-md-4">
            <div className="work-box">
              <div className="work-img">
                <img src={Saxen} alt="cover for saxen barbershop" className="img-fluid" />
              </div>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12">
                    <h2 className="w-title">Saxen Barbershop</h2>
                    <p className="box-info">
                      Responsive one page landing page for barbershop.
                    </p>
                    <span className="JS">
                      <iconify-icon data-icon="mdi:language-javascript" />
                    </span>
                    <span className="HTML">
                      <iconify-icon data-icon="akar-icons:html-fill" />
                    </span>
                    <span className="CSS">
                      <iconify-icon data-icon="akar-icons:css-fill" />
                    </span>
                  </div>
                  <div className="col-sm-12">
                    <div className="socials">
                      <a
                        href="https://www.saxenbarbershop.se/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ico-circle">
                          <i className="ion-link" />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="col-md-4">
            <div className="work-box">
              <div className="work-img">
                <img src={ADP2} alt="coverfor landing page" className="img-fluid" />
              </div>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12">
                    <h2 className="w-title">AD Performance</h2>
                    <p className="box-info">
                    Responsive one page landing page for sports performance company.
                    </p>
                    <span className="JS">
                      <iconify-icon data-icon="mdi:language-javascript" />
                    </span>
                    <span className="HTML">
                      <iconify-icon data-icon="akar-icons:html-fill" />
                    </span>
                    <span className="CSS">
                      <iconify-icon data-icon="akar-icons:css-fill" />
                    </span>
                  </div>
                  <div className="col-sm-12">
                    <div className="socials">

                        <a
                          href="https://adperformance.netlify.app/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="ico-circle">
                            <i className="ion-link" />
                          </span>
                        </a>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*DESIGN Section*/}
          <div className="col-sm-12">
            <div className="title-box text-center">
              <p className="subtitle-a">
                UX/UI Projects
                <span role="img" aria-label="emoji-designer">
                  👨‍🎨
                </span>
                <br />
              </p>
              <div className="line-mf" />
            </div>
          </div>
          {/* Project  7*/}
          <div className="col-md-4">
            <div className="work-box">
              <div className="work-img">
                <img src={Barber} alt="landing-page-cover" className="img-fluid" />
              </div>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12">
                    <h2 className="w-title">Gentlecuts</h2>
                    <p className="box-info">
                      A barbershop landing page with booking integration. UX case study to
                      development.
                    </p>
                    <span className="TS">
                      <iconify-icon data-icon="mdi:language-typescript" />
                    </span>
                    <span className="RS">
                      <iconify-icon data-icon="mdi:react" />
                    </span>
                    <span className="FIREBASE">
                      <iconify-icon data-icon="bxl:firebase" />
                    </span>
                    <span className="FIGMA">
                      <iconify-icon data-icon="gg:figma" />
                    </span>
                    <span className="UX-Case">
                      <iconify-icon data-icon="majesticons:ux-circle-line" />
                    </span>
                  </div>
                  <div className="col-sm-12">
                    <div className="socials">
                      <a
                        href="https://www.figma.com/file/rsc1ijWUYpr6MSsny3sssZ/GENTLE-CUTS-Wireframe"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="iconify-share">
                          <span className="wireframe">
                            <iconify-icon data-icon="openmoji:wireframes" />
                          </span>
                        </div>

                        <a
                          href="https://www.figma.com/file/HXZARKaEohxP2nru0fV25i/Barber-Shop?node-id=0%3A1"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="ico-circle">
                            <span className="case-study">
                              <i className="ion-search" />
                            </span>
                          </div>
                          <a
                            href="https://gentlecuts-v2.netlify.app"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span className="ico-circle">
                              <i className="ion-link" />
                            </span>
                          </a>
                        </a>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Project  8*/}
          <div className="col-md-4">
            <div className="work-box">
              <div className="work-img">
                <img src={EuBike} alt="eu-bike" className="img-fluid" />
              </div>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12">
                    <h2 className="w-title">EU-Bike</h2>
                    <p class="box-info">
                      UX-Case study of EU-Bike. A rental bicycles service located in
                      Stockholm & Uppsala.
                    </p>
                    <span className="FIGMA">
                      <iconify-icon data-icon="gg:figma" />
                    </span>

                    <span className="UX-Case">
                      <iconify-icon data-icon="majesticons:ux-circle-line" />
                    </span>
                  </div>
                  <div className="col-sm-12">
                    <div className="socials">
                      <a
                        href="https://www.figma.com/file/fZjEwbip4ecAAIcdfbCTKL/EU-BIKE-Prototype?node-id=78%3A0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="iconify-share">
                          <span className="wireframe">
                            <iconify-icon data-icon="openmoji:wireframes" />
                          </span>
                        </div>
                      </a>

                      <a
                        href="https://www.figma.com/file/xFBGgoP57NF68eQu3FA42k/Case-Study-Template-(Community)-(Copy)?node-id=6%3A14&t=qXgcfv55vGGwCKca-1"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="ico-circle">
                          <span className="case-study">
                            <i className="ion-search" />
                          </span>
                        </div>
                      </a>

                      <a
                        href="https://www.figma.com/proto/fZjEwbip4ecAAIcdfbCTKL/EU-BIKE-Prototype?page-id=39%3A2&node-id=39%3A2963&scaling=scale-down&starting-point-node-id=39%3A2963&show-proto-sidebar=1"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="ico-circle">
                          <span className="prototype">
                            <i className="ion-link" />
                          </span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Project  9*/}
          <div className="col-md-4">
            <div className="work-box">
              <div className="work-img">
                <img src={SoupLoop} alt="soup-loop-cover" className="img-fluid" />
              </div>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12">
                    <h2 className="w-title">The Soup Loop</h2>
                    <p className="box-info">
                      An online soup delivery service. Wireframes & Prototype. Case study
                      cooming soon.
                    </p>
                    <span className="FIGMA">
                      <iconify-icon data-icon="gg:figma" />
                    </span>
                  </div>
                  <div className="col-sm-12">
                    <div className="socials">
                      <a
                        href="https://www.figma.com/file/3ahSbwfsHFP0ZpDHDSXkoV/Soup-Theme?node-id=106%3A77"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="iconify-share">
                          <span className="wireframe">
                            <iconify-icon data-icon="openmoji:wireframes" />
                          </span>
                        </div>
                      </a>
                      <a
                        href="https://www.figma.com/proto/3ahSbwfsHFP0ZpDHDSXkoV/Soup-Theme?node-id=106%3A318&scaling=scale-down&page-id=106%3A77&starting-point-node-id=106%3A318&show-proto-sidebar=1"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="ico-circle">
                          <span className="prototype">
                            <i className="ion-link" />
                          </span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Portfolio
